module.exports = __webpack_public_path__ + "static/media/cv.383ab620.svg";